export default {
  install(Vue) {
    Vue.config.globalProperties.tableHeight = 580; //表格最大高度
    Vue.config.globalProperties.baseURL = baseURL;
    Vue.config.globalProperties.imageURL = baseURL + '/static/img/';
    Vue.config.globalProperties.filePath = filePath;
    Vue.config.globalProperties.getDict = function (dictType) {
      return this.$store.state.dictMap[dictType];
    };

    Vue.config.globalProperties.message = function(msg){
      if(!msg)msg='操作成功';
      this.$message({type: 'success', message: msg});
    };
    Vue.config.globalProperties.messageInfo = function(msg){
      if(!msg)msg='已取消';
      this.$message({type: 'info', message: msg});
    };
    Vue.config.globalProperties.messageError = function(msg){
      this.$message({type: 'error', message: msg});
    };
    Vue.config.globalProperties.msgAlert = function (msg, callbackMethod) {
      this.$alert(msg, '信息提示', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (!$.isEmpty(callbackMethod)) callbackMethod();
        }
      });
    };
    Vue.config.globalProperties.shopTypeArr = [{label:"代理商",value:"0"},{label:"加盟商",value:"1"},{label:"员工主管",value:"2"},{label:"维护员工",value:"3"},{label:"商家",value:"4"}];

    Vue.config.globalProperties.selectOneWarn = function () {
      this.$message({type: 'warning', message: '请先选择一个操作项'});
    };
    Vue.config.globalProperties.getItems = function (key, obj) {
      if ($.isEmpty(key)) key = 'id';
      var ids = [];
      obj = obj ? obj : this.selectItems;
      if($.isNotEmpty(obj)){
        obj.forEach(function (item) {
          ids.push(item[key]);
        });
      }
      return ids;
    };
    Vue.config.globalProperties.deleteConfirm = function (url, data, result, msg) {
      if (this.selectItems.length === 0) {
        this.selectOneWarn();
      } else {
        this.msgConfirm(url, data, result, msg);
      }
    };
    Vue.config.globalProperties.showConfirm = function (msg, result, catchCallBack) {
      var _this = this;
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        result&&result();
      }).catch(res=>{
        catchCallBack&&catchCallBack(res);
      });
    };
    Vue.config.globalProperties.msgConfirm = function (url, data, result, msg) {
      if ($.isEmpty(msg)) msg = "此操作将永久删除该信息, 是否继续?";
      var _this = this;
      this.showConfirm(msg, function () {
        _this.simplePost(url, data, function (obj) {
          if ($.isNotEmpty(result)) {
            result(obj);
          } else {
            _this.search();
          }
        });
      });
    };

    Vue.config.globalProperties.simpleGet = function (url, data, result, async) {
      this.simpleAjax(url, _GET, data, result, async);
    };
    Vue.config.globalProperties.simplePost = function (url, data, result, async, errorMethod) {
      this.simpleAjax(url, _POST, data, result, async, false, errorMethod);
    };
    Vue.config.globalProperties.checkSubmitPost = function (formName,url, data, result, async, errorMethod) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.simplePost(url,data,result,async,errorMethod);
        }
      });
    };
    Vue.config.globalProperties.uploadFile = function(file,result,errorMethod){
      var formData = new FormData();
      formData.append('file', file);
      let _this = this;
      $.ajax({
        url: "/api/mgr/upload/location/uploadFile",
        data: formData,
        type:_POST,
        dataType: "json",
        contentType: false,
        processData: false,
        success: function success(obj) {
          if (obj.code === '0') {
            result&&result(obj);
          } else if (obj.code === '9001' ||obj.code === '-309'||obj.code === '-308') {//系统后台
            _this.msgError(obj.desc, function () {
              _this.$router.push({path: '/'});
            });
          } else {
            if (errorMethod) {
              errorMethod(obj)
            }else{
              _this.msgError(obj.desc);
            }
          }
        },
        beforeSend: function beforeSend(xhr) {
          let token = localStorage.getItem("qc_token");
          if(token){
            xhr.setRequestHeader("token",token);
          }
          _this.loading = true;
        },
        error: function error() {
          _this.loading = false;
          if (errorMethod) {
            errorMethod()
          } else {
            _this.msgError("网络错误,请联系管理员");
          }
        }
      });
    }
    Vue.config.globalProperties.loadPageData = function (url, data, result) {
      if ($.isEmpty(data)) data = {};
      var _that = this;
      this.$nextTick( ()=> {
        data.pageNum = _that.$refs.page.currentPage;
        data.pageSize = _that.$refs.page.pageSize;
        if ($.isNotEmpty(_that.searchObj)) {
          $.each(_that.searchObj, function (i, o) {
            if ($.isNotEmpty(o)) {
              if (o instanceof String) {
                data[i] = o.trim();
              } else {
                data[i] = o;
              }
            }
          });
        }
        _that.simpleAjax(url, _POST, data, result, true, true);
      });
    };
    Vue.config.globalProperties.simpleAjax = function (url, type, data, result, async, isLoadPage, errorMethod) {
      if ($.isEmpty(async)) async = true; //默认异步加载
      if ($.isEmpty(isLoadPage)) isLoadPage = false;
      if ($.isEmpty(data)) data = {};
      url = $.handleUrl(url);
      var contentType = _CONTENT_TYPE_DEFUALT;
      if ($.isNotEmpty(data.contentType)) {
        contentType = data.contentType;
        delete data.contentType;
        if (contentType == _CONTENT_TYPE_JSON) {
          data = data.list ? JSON.stringify(data.list) : JSON.stringify(data);
        }
      }
      let processData = true;
      if(data instanceof FormData){
        contentType = false;
        processData = false;
      }

      var _this = this;
      $.ajax({
        url: url,
        data: data,
        dataType: "json",
        type: type,
        async: async,
        processData:processData,
        contentType: contentType,
        success: function success(obj) {
          _this.loading = false;
          document.body.classList.remove("el-popup-parent--hidden");
          if (obj.code === '0') {
            if (isLoadPage) {
              _this.$refs.page.total = 0 || obj.data.totalRecord;
              _this.tableData = obj.data.results || [];
            }
            if (!$.isEmpty(result)) {
              result(obj);
            } else if (!isLoadPage) {
              _this.message(obj.desc);
            }
            /*console.log(obj)
            if (obj.data) {
              console.log(1)
              console.log(obj.data.code)
              if (obj.data.code === '1002') {
                console.log(2)
                _this.msgAlert(obj.data.desc)
              }
            }*/

          } /*else if (obj.code === '8801') {//超管后台
            _this.messageError(obj.desc, function () {
              window.location.href = baseURL + "/jsp/default/login/login_in.jsp";
            });

          } */else if ( obj.code === '9001' ||obj.code === '-309'||obj.code === '-308') {//系统后台
            if(errorMethod){
              errorMethod(obj);
            }else{
              _this.msgAlert(obj.desc, function () {
                  _this.$router.push({path: '/'});

              });
            }
          } else {
            if (errorMethod) {
              errorMethod(obj)
            }else{
              _this.messageError(obj.desc);
            }
          }
        },
        beforeSend: function beforeSend(xhr) {
          let token = localStorage.getItem("qc_token");
          if(token){
            xhr.setRequestHeader("token",token);
          }


          let superToken = localStorage.getItem("qc_super_token");
          if(superToken){
            xhr.setRequestHeader("superToken",superToken);
          }
          _this.loading = true;
        },
        error: function error() {
          _this.loading = false;
          if (errorMethod) {
            errorMethod()
          } else {
            _this.messageError("网络错误,请联系管理员");
          }
        }
      });
    };


    Vue.config.globalProperties._windowTo = function (event, url, data, title) {
      //利用window加密
      var param = "?code=" + btoa(encodeURIComponent($.param(data)));
      $(event.target).attr("data-href", url + param);
      //$(event.target).attr("tabItem", tabItem + data.id);
      commonOpen(event.target, title);
    };
    Vue.config.globalProperties.getUrlKey = function (name) {
      let value = decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(this.getCode()) || [, ""])[1].replace(/\+/g, '%20'));
      if ($.isEmpty(value)) {
        return "";
      }
      return value;
    };
    Vue.config.globalProperties.getCode = function () {
      var code = (new RegExp('[?]code=([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20');
      return "?" + decodeURIComponent(atob(code));
    };

    Vue.config.globalProperties.getUrlKey2 = function (name) {
      let value = decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [""])[1].replace(/\+/g, '%20'));
      if ($.isEmpty(value)) {
        return "";
      }
      return value;
    };
    Vue.config.globalProperties.getUrlKey3 = function (url,name) {
      let value = decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [""])[1].replace(/\+/g, '%20'));
      if ($.isEmpty(value)) {
        return "";
      }
      return value;
    };
    /**
     * 过滤日期
     * @param params
     */
    Vue.config.globalProperties.filterDate = function (params) {
      if (!params || params.length <= 0) return;
      for (var i = 0; i < params.length; i++) {
        var _params$i = params[i],
          obj = _params$i.obj,
          fields = _params$i.fields,
          pattern = _params$i.pattern;

        pattern = pattern || 'yyyy-MM-dd hh:mm:ss';
        if (!obj || !fields || fields.length <= 0) return;
        for (var _i = 0; _i < fields.length; _i++) {
          if (this[obj][fields[_i]] instanceof Date && Date.prototype.Format) {
            this[obj][fields[_i]] = this[obj][fields[_i]].Format(pattern);
          }
        }
      }
    };


    Vue.config.globalProperties.validDoc = function (file) {
      var fileName = file.name;
      var fileExt = "|" + fileName.substr(fileName.lastIndexOf(".") + 1, fileName.length - 1) + "|";
      if ("|doc|docx|xls|xlsx|pdf|txt|DOC|DOCX|XLS|XLSX|PDF|TXT|".indexOf(fileExt) >= 0) {
        return true;
      }
      this.$message({type: 'error', message: '上传文件格式不符合'});
      return false;
    };
    Vue.config.globalProperties.validExcelXML = function (file,callback) {
      var fileName = file.name;
      var fileExt = "|" + fileName.substr(fileName.lastIndexOf(".") + 1, fileName.length - 1) + "|";
      if ("|XML|XLS|XLSX|CSV|".indexOf(fileExt.toUpperCase()) >= 0) {
        callback&&callback();
        return true;
      }
      this.$message({type: 'error', message: '上传文件格式不符合'});
      return false;
    };
    Vue.config.globalProperties.validVideo = function (file,callback) {
      var fileName = file.name;
      var fileExt = "|" + fileName.substr(fileName.lastIndexOf(".") + 1, fileName.length - 1) + "|";
      if ("|RM|RMVB|VOB|FLV|MKV|OGG|MP4|M4V|MOV|3GP|ASF|WMV|AVI|".indexOf(fileExt.toUpperCase()) >= 0) {
        callback&&callback()
        return true;
      }
      this.$message({type: 'error', message: '上传视频格式不符合'});
      return false;
    };
    Vue.config.globalProperties.validAudio = function (file,callback) {
      var fileName = file.name;
      var fileExt = "|" + fileName.substr(fileName.lastIndexOf(".") + 1, fileName.length - 1) + "|";
      if ("|MP3|WAV|WMA|MID|AAC|OGA|APE|FLAC|MPC|M4A|".indexOf(fileExt.toUpperCase()) >= 0) {
        callback&&callback()
        return true;
      }
      this.$message({type: 'error', message: '上传音频格式不符合'});
      return false;
    };
    Vue.config.globalProperties.validImage = function (file, callback) {
      var fileName = file.name;
      var fileExt = "|" + fileName.substr(fileName.lastIndexOf(".") + 1, fileName.length - 1) + "|";
      if ("|JPG|PNG|GIF|BMP|TIF|JPEG|".indexOf(fileExt.toUpperCase()) >= 0) {
        if (callback) {
          const isLt2M = file.size / 1024 / 1024 < 20;
          if (!isLt2M) {
            this.$message.error('上传图片大小不能超过 20MB!');
            return false;
          }
          return callback();
        }
      }
      this.$message({type: 'error', message: '上传图片格式不符合'});
      return false;
    };
    Vue.config.globalProperties.validBook = function (file) {
      var fileName = file.name;
      var fileExt = "|" + fileName.substr(fileName.lastIndexOf(".") + 1, fileName.length - 1) + "|";
      if ("|PDF|".indexOf(fileExt) >= 0) {
        return true;
      }
      this.$message({type: 'error', message: '上传文件格式不符合'});
      return false;
    }

    Vue.config.globalProperties.validZIP = function (file,callback) {
      var fileName = file.name;
      var fileExt = "|" + fileName.substr(fileName.lastIndexOf(".") + 1, fileName.length - 1) + "|";
      if ("|ZIP|".indexOf(fileExt.toUpperCase()) >= 0) {
        callback&&callback();
        return true;
      }
      this.$message({type: 'error', message: '上传文件格式不符合'});
      return false;
    };

    /** 添加http end方法 **/
    Vue.config.globalProperties.copyOption = function (dist, resource) {
      $.each(dist, function (i, o) {
        dist[i] = resource[i];
      });
    }

    Vue.config.globalProperties.copyObj = function (odlObj) {//复制对象
      var newobj = {};
      for (var attr in odlObj) {
        newobj[attr] = odlObj[attr];
      }
      return newobj;
    };
    Vue.config.globalProperties.copyObjDeep = function (odlObj) {//深拷贝对象
      return JSON.parse(JSON.stringify(odlObj));
    };


    Vue.config.globalProperties.copyList = function (sourceList) {//复制对象
      if(sourceList.length===0){
        return [];
      }
      var arr = [];
      sourceList.forEach(row=>{
        if(typeof row == "object"){
          arr.push(this.copyObj(row));
        }else{
          arr.push(row);
        }
      })
      return arr;
    };
    Vue.config.globalProperties.resetForm = function (formName) {
      this.$refs[formName].resetFields();
    };
    Vue.config.globalProperties.clearTrim = function (obj) {
      $.each(obj, function (i, o) {
        if ($.isNotEmpty(o) && typeof(o) == 'string') {
          obj[i] = o.trim();
        }
      });
      return obj;
    };
    Vue.config.globalProperties.initJCryption = function(el,button,call,errorCall){
      var that = this;
      var $el = $(el);
      var $button = $(button);
      $el.jCryption({
        submitElement: $button,
        finishEncryption: function ($formElement, encrypted) {
          // 需要自己做提交表单处理，如果不配置此项会自动提交
          $formElement.ajaxSubmit({
            dataType: 'json',
            async: false,
            success: function (result) {
              that.loading = false;
              if (result.code == 0) {
                call(result);
              } else {
                if(errorCall){
                  errorCall(result);
                }else{
                   that.msgAlert(result.desc)
                }
              }
            },
            beforeSend(xhr){
              xhr.setRequestHeader("token",localStorage.getItem("qc_token"));
              that.loading = true;
            },
            error() {
              that.loading = false;
              that.messageError("网络错误,请联系管理员");
            }
          })
        }
      })
    };
    /**
     * 头像错误显示默认头像
     */
    Vue.config.globalProperties.errorAvator = function(e){
      e.target.src = 'static/image/pc_icon2.png'
    };
    /**
     * 错误默认封面图片
     */
    Vue.config.globalProperties.errorCover= function(e){
      e.target.src = "static/image/default_cover.png";
    };


    Vue.config.globalProperties.changeThemeStyle= function(theme){
      for(let key in menusModel[theme]){
        document.getElementsByTagName('body')[0].style.setProperty(`--${key}`, menusModel[theme][key]);
      }
      document.body.className="custom-"+theme;
    }
    Vue.config.globalProperties.getThemeStyle = function(key){
      return document.getElementsByTagName('body')[0].style.getPropertyValue(`--${key}`);
    }

    Vue.config.globalProperties.getCookie = function (name) {
      var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
    }

    Vue.config.globalProperties.setCookie = function(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = "expires="+d.toUTCString();
      document.cookie = cname + "=" + cvalue + "; " + expires;
    }
    Vue.config.globalProperties.uploadQiNiu = function(localFile,success,error){
      var config = new qiniu.conf.Config();
      config.zone = qiniu.zone.Zone_z2;
      var formUploader = new qiniu.form_up.FormUploader(config);
      var putExtra = new qiniu.form_up.PutExtra();
      var key=uuid();
      // 文件上传
      formUploader.putFile(this.getQiNiuToken(), key, localFile, putExtra, function(respErr, respBody, respInfo) {
        if (respErr) {
          throw respErr;
        }
        if (respInfo.statusCode == 200) {
          success&&success(respBody);
        } else {
          if(respInfo.statusCode== 401){
            //清除重新获取
            this.$store.commit("addQiNiuToken",null);
            this.uploadQiNiu();
          }else{
            error&&error(respBody);
          }
          console.log(respBody);
        }
      });
    }

    Vue.config.globalProperties.getQiNiuToken = function(){
      let token = null;
      this.simplePost("/api/mgr/upload/getQiNiuToken",null,result=>{
        token = result.data;
      },false)
      return token;
      /*let token = this.$store.state.qiNiuToken;
      if(!token){
        this.simplePost("/api/mgr/upload/getQiNiuToken",null,result=>{
          token = result.data;
          this.$store.commit("addQiNiuToken",result.data);
        },false)
      }
      return token;*/
    }

    Vue.config.globalProperties.exportExcelFile = function (url,msg,data){
      if ($.isEmpty(msg)) msg = "确认导出Excel文件?";
      this.showConfirm(msg, function () {
        $.submitFormPost(url,data);
      });
    }

    Vue.config.globalProperties.inputFiltrationLetter = function(val){
       return val.replace(/[^\d]/g,'')
    }

    Vue.config.globalProperties.formatBankAccount = function(val){
      if (val){
        return val.replace(/\s/g,'').replace(/(\d{4})(?=\d)/g,"$1 ")
      }
    }
    Vue.config.globalProperties.filterFileName = function(url,fileName){
      var fileExt = url.substr(url.lastIndexOf("."), url.length - 1);
      return fileName+fileExt;
    }

    Vue.config.globalProperties.numMul = function(arg1,arg2){
      let m = 0;
      let s1 = arg1.toString();
      let s2 = arg2.toString();
      try {
        m += s1.split(".")[1].length;
      } catch (e) {}
      try {
        m += s2.split(".")[1].length;
      } catch (e) {}

      return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
    }
    Vue.config.globalProperties.numAdd = function(a,b){
      var c, d, e;
      try {
        c = a.toString().split(".")[1].length;
      } catch (f) {
        c = 0;
      }
      try {
        d = b.toString().split(".")[1].length;
      } catch (f) {
        d = 0;
      }
      return e = Math.pow(10, Math.max(c, d)), (this.numMul(a, e) + this.numMul(b, e)) / e;
    }
  }



}
